/**
 * @class Oskari.mapframework.bundle.featuredata.FeatureDataBundleInstance
 *
 * Main component and starting point for the "featuredata" functionality.
 *
 * See Oskari.mapframework.bundle.featuredata.FeatureDataBundle for bundle definition.
 *
 */

import { FEATUREDATA_BUNDLE_ID } from './view/FeatureDataContainer';
import { SelectToolPopupHandler } from './view/SelectToolPopupHandler.js';
import './publisher/FeaturedataTool';
Oskari.clazz.define('Oskari.mapframework.bundle.featuredata.FeatureDataBundleInstance', function () {}, {
  /**
   * @static
   * @property __name
   */
  __name: 'FeatureData',
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method onEvent
   * @param {Oskari.mapframework.event.Event} event a Oskari event object
   * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
   */
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  /**
   * @method init
   * implements Module protocol init method - does nothing atm
   */
  init: function init() {
    this.requestHandlers = {
      showFeaturedataHandler: Oskari.clazz.create('Oskari.mapframework.bundle.featuredata.request.ShowFeatureDataRequestHandler', this)
    };
  },
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  getMapModule: function getMapModule() {
    return this.mapModule;
  },
  start: function start() {
    var _this = this;
    var sandboxName = (this.conf ? this.conf.sandbox : null) || 'sandbox';
    this.sandbox = Oskari.getSandbox(sandboxName);
    this.sandbox.register(this);
    this.mapModule = this.sandbox.findRegisteredModuleInstance('MainMapModule');
    Object.getOwnPropertyNames(this.eventHandlers).forEach(function (p) {
      return _this.sandbox.registerForEventByName(_this, p);
    });
    this.createUi();
    if (this.conf && this.conf.selectionTools === true) {
      this.selectToolPopupHandler = new SelectToolPopupHandler(this);
      var addBtnRequestBuilder = Oskari.requestBuilder('Toolbar.AddToolButtonRequest');
      var btn = {
        iconCls: 'tool-feature-selection',
        tooltip: Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'selectionTools.tools.select.tooltip'),
        sticky: true,
        callback: function callback() {
          return _this.selectToolPopupHandler.showSelectionPopup();
        }
      };
      this.getSandbox().request(this, addBtnRequestBuilder('featuredataSelectionTools', 'selectiontools', btn));
    }
    this.sandbox.requestHandler('ShowFeatureDataRequest', this.requestHandlers.showFeaturedataHandler);
    this.__setupLayerTools();
  },
  /**
   * @method createUi
   * (re)creates the UI for "selected layers" functionality
   */
  createUi: function createUi() {
    this.plugin = Oskari.clazz.create('Oskari.mapframework.bundle.featuredata.plugin.FeaturedataPlugin', this.conf);
    this.mapModule.registerPlugin(this.plugin);
    this.mapModule.startPlugin(this.plugin);
  },
  /**
   * Fetches reference to the map layer service
   * @return {Oskari.mapframework.service.MapLayerService}
   */
  getLayerService: function getLayerService() {
    return this.sandbox.getService('Oskari.mapframework.service.MapLayerService');
  },
  /**
   * Adds tools for all layers
   */
  __setupLayerTools: function __setupLayerTools() {
    var _this2 = this;
    // add tools for feature data layers
    this.getLayerService().getAllLayers().filter(function (layer) {
      return layer.hasFeatureData();
    }).forEach(function (layer) {
      return _this2.__addTool(layer, true);
    });
    // update all layers at once since we suppressed individual events
    var event = Oskari.eventBuilder('MapLayerEvent')(null, 'tool');
    this.sandbox.notifyAll(event);
  },
  /**
   * Adds the Feature data tool for layer
   * @param  {Object} layer layer to process
   * @param  {Boolean} suppressEvent true to not send event about updated layer (optional)
   */
  __addTool: function __addTool(layer, suppressEvent) {
    var _this3 = this;
    if (!layer || !layer.hasFeatureData()) {
      return;
    }
    // add feature data tool for layer
    var tool = Oskari.clazz.create('Oskari.mapframework.domain.Tool');
    var label = Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'layer.featureData');
    tool.setName('featureData');
    tool.setIconCls('show-featuredata-tool');
    tool.setTitle(label);
    tool.setTooltip(label);
    tool.setCallback(function () {
      return _this3.sandbox.postRequestByName('ShowFeatureDataRequest', [layer.getId()]);
    });
    this.getLayerService().addToolForLayer(layer, tool, suppressEvent);
  },
  eventHandlers: {
    MapLayerEvent: function MapLayerEvent(event) {
      if (event.getOperation() !== 'add') {
        // only handle add layer
        return;
      }
      var id = event.getLayerId();
      if (id) {
        var layer = this.getLayerService().findMapLayer(id);
        this.__addTool(layer);
      } else {
        // ajax call for all layers
        this.__setupLayerTools();
      }
    }
  }
});